<template>
  <div class="section" :class="$mq">
    <div class="title">{{ $t("step2.inhabitant.title") }}</div>
    <div class="container inline center h-item-margin margin no-legend">
      <div class="frame action content-centered" :class="$mq" @click="decrease()">
        <SvgIcon icon="decrease" class="icon content-centered" fill />
      </div>
      <div class="frame content-centered active">
        <SvgIcon
          v-if="people < 4"
          :icon="`${people}-inhabitant`"
          class="icon inhabitant content-centered"
          :class="{TA:isTestAchat}"
          fill
          :key="people"
        />
        <SvgIcon v-else icon="4-inhabitant" class="icon inhabitant content-centered" :class="{TA:isTestAchat}" fill />
        <span class="count" :class="$mq" v-if="people < 7">{{ people }}</span>
        <span class="count" :class="$mq" v-if="people === 7">7+</span>
      </div>
      <div class="frame action content-centered" :class="$mq" @click="increase()">
        <SvgIcon icon="increase" class="icon content-centered" fill />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapState("consumption", ["people"]),
    ...mapGetters("common", ["isTestAchat"])
  },
  methods: {
    increase() {
      this.$store.commit("consumption/increasePeople");
    },
    decrease() {
      this.$store.commit("consumption/decreasePeople");
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;

  .frame {
    flex: 0!important;
  }
}

.inhabitant {
  color: #fdcb47;
}
.action {
  .icon {
      cursor: pointer;
      padding: 20px;
      width: 50px !important;
      height: 50px !important;
      border: 0 !important;
      box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.12);
      border-radius: 20%;
      color: $black !important;
      padding: 15px;
      width: 10px !important;
      height: 10px !important;
      background: #ccc !important;
  }
}

.icon {
  font-size: 3rem;
  width: 70px;
  height: 70px;
  border-radius: 20%;
  color: $black;
  background: linear-gradient(136deg, #fdcb47, #fcc648);
  box-shadow: 5px 10px 10px #4d545a12;
}

.count {
  cursor: default;
  position: absolute;
  left: calc(50%);
  padding: 2px 10px;
  background: $black;
  border-radius: 50px;
  color: $white;
  font-size: 0.7rem;
  top: 62px;
}
</style>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/Inhabitant.vue